import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DesktopLayout from '../../components/layout/DesktopLayout';
import WishForm from '../../components/wishes/WishForm';
import './WishFormPage.css';

const WishFormPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="wish-form-page">
        <DesktopLayout>
          <main className="wish-form-page__main">
            <div className="wish-form-page__loading">載入中...</div>
          </main>
        </DesktopLayout>
      </div>
    );
  }

  // Don't render form if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="wish-form-page">
      <DesktopLayout>
        <main className="wish-form-page__main">
          <WishForm />
        </main>
      </DesktopLayout>
    </div>
  );
};

export default WishFormPage;
